import Skeleton from 'react-loading-skeleton';

export const VideosChannelLoadingState = () => (
  <>
    <Skeleton className="mt-6 stihl-text-h4-mobile tablet:mt-14 tablet:stihl-text-h4-desktop" width={250} />
    <div className="mt-6 flex flex-col tablet:flex-row tablet:space-x-6 mobileOnly:space-y-6 miniTabletOnly:space-y-6">
      <div className="w-full">
        <Skeleton className="flex h-[10rem] flex-col tablet:w-full" />
        <div className="flex flex-col justify-center">
          <Skeleton />
          <Skeleton />
        </div>
      </div>
    </div>
    <Skeleton className="mt-12 h-[3rem] w-[14rem]" />
  </>
);
